module.exports = __webpack_public_path__ + "static/media/Brazen_Abelgas_Resume.c766b15d.pdf";